import dynamic from "next/dynamic";

export const TableSelectFilter = dynamic(() => import("./TableSelectFilter"), {
  ssr: false,
});

export const TableFilterIcon = dynamic(() => import("./TableFilterIcon"), {
  ssr: false,
});

export const TableDateFilter = dynamic(() => import("./TableDateFilter"), {
  ssr: false,
});
